
import Session from '@/utils/session'
import initialState from './initialState'

const apiKey = Session.getSecret()

const state = {
  ...initialState(),
  apiKey,
  access: Boolean(apiKey)
}

export default state